import React from "react";
import FlightWizardLiveSummary from "./wizard/FlightWizardLiveSummary";
import { useBookingFlow } from "./hooks/useBookingFlow";
import { useSearch } from "../../../contexts/SearchContext";
import { useSelectedResult } from "../../../contexts/SelectedResultContext";
import { useFlightRealProposalSubmit } from "./context/FlightRealProposalSubmitContext";
import HandlingFeePicker from "../../Agent/PaymentAgent/HandlingFeePicker/HandlingFeePicker";
import FlightDecisionCta from "./flightDetailsDecision/FlightDecisionCta";
import FlightSummaryRail from "./FlightSummaryRail";

export default function FlightBookingSidebar() {
  const {
    currentStep,
    pricing,
    canAdvanceFromCurrentStep,
    recomputePricingNow,
    selectedFlightOffer,
  } = useBookingFlow();
  const {
    selectedSelfComposeOutboundDeal,
    selectedSelfComposeInboundDeal,
  } = useSearch();
  const { handleFeeData, updateHandleFeeData } = useSelectedResult();
  const {
    createDraftFromFlightDetails,
    isCreatingDraftFromFlightDetails,
    flightQuoteCreateResult,
    clearFlightQuoteCreateResult,
  } = useFlightRealProposalSubmit();

  const isFlightDetailsStep = currentStep === "flightDetails";
  const isSelfComposePick = currentStep === "selfComposePick";
  const bothSelfComposeLegs = !!(
    selectedSelfComposeOutboundDeal && selectedSelfComposeInboundDeal
  );
  const hasSelectedFlightOffer = selectedFlightOffer != null;
  // Hide $0 / "price unavailable" סיכום הזמנה until a real offer (or both legs).
  const showOrderSummaryCard = isSelfComposePick
    ? bothSelfComposeLegs
    : hasSelectedFlightOffer;
  // Duplicate itinerary chrome (route / ציר טיסות / פרטי הטיסה / נוסעים / CTA)
  // already lives in the main column on self-compose pick + summary.
  const showDetailsStack = !isSelfComposePick && hasSelectedFlightOffer;
  // SSOT: managedOurTotalFare נקרא ישירות מ-pricing של הפלואו.
  const managedPricePreview =
    isFlightDetailsStep && pricing?.managedOurTotalFare
      ? pricing.managedOurTotalFare
      : null;
  const handleFeeChange = (type, value) => {
    updateHandleFeeData(type, value);
    // עדכון מיידי ללא המתנה ל-render של SelectedResultContext.
    recomputePricingNow({ handleFeeData: { type, value } });
  };

  const agentBlock = isFlightDetailsStep ? (
    <section className="fd-card fd-agent-mgmt" aria-label="ניהול חבילה סוכן">
      <h3 className="fd-agent-mgmt__title">ניהול חבילה (סוכן)</h3>
      <HandlingFeePicker
        extendHandleFeeDefault={true}
        handleFeeData={handleFeeData}
        updateHandleFeeData={handleFeeChange}
        ourPrice={managedPricePreview || undefined}
        fixedFeeStoredCurrency="ILS"
        orderId="newOrder"
      />
    </section>
  ) : null;

  const actionsBlock = isFlightDetailsStep ? (
    <FlightDecisionCta
      showPriceBlock={false}
      showContinueButton={false}
      onCreateQuote={createDraftFromFlightDetails}
      disabled={!canAdvanceFromCurrentStep()}
      creatingQuote={isCreatingDraftFromFlightDetails}
      quoteSuccess={flightQuoteCreateResult}
      onClearQuoteSuccess={clearFlightQuoteCreateResult}
    />
  ) : null;

  if (!showOrderSummaryCard && !agentBlock && !actionsBlock && !showDetailsStack) {
    return null;
  }

  return (
    <FlightSummaryRail
      variant="flight-booking"
      stackClassName="fw-summary-stack--flight-booking"
      renderStack={({ compact }) => (
        <>
          {showOrderSummaryCard ? (
            <div
              className="fw-summary-stack__block fb-booking-sidebar__region fb-booking-sidebar__region--summary"
              data-sidebar-block="summary"
              data-state="summary"
            >
              <FlightWizardLiveSummary compact={!!compact} layoutVariant="priceOnly" />
            </div>
          ) : null}
          {agentBlock ? (
            <div
              className="fw-summary-stack__block fb-booking-sidebar__region fb-booking-sidebar__region--agent"
              data-sidebar-block="agent"
              data-state="active"
            >
              {agentBlock}
            </div>
          ) : null}
          {actionsBlock ? (
            <div
              className="fw-summary-stack__block fb-booking-sidebar__region fb-booking-sidebar__region--actions"
              data-sidebar-block="actions"
              data-state="active"
            >
              {actionsBlock}
            </div>
          ) : null}
          {showDetailsStack ? (
            <div
              className="fw-summary-stack__block fb-booking-sidebar__region fb-booking-sidebar__region--details"
              data-sidebar-block="details"
              data-state="details"
            >
              <FlightWizardLiveSummary compact={!!compact} layoutVariant="detailsOnly" />
            </div>
          ) : null}
        </>
      )}
    />
  );
}
